module.exports = __webpack_public_path__ + "static/media/fb.77cb5cb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/fb.svg
// module id = 286
// module chunks = 0